import { render, staticRenderFns } from "./TokKidsPage.vue?vue&type=template&id=d1bc31e8&scoped=true"
import script from "./TokKidsPage.vue?vue&type=script&lang=ts"
export * from "./TokKidsPage.vue?vue&type=script&lang=ts"
import style0 from "./TokKidsPage.vue?vue&type=style&index=0&id=d1bc31e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bc31e8",
  null
  
)

export default component.exports